import React, { Component } from 'react';

//styles
import './sectionTwo.scss';
import '../../static/fonts/Rubik/stylesheet.css'

class SectionTwo extends Component {
    componentDidMount() {
    }

    render() {
        return (
            <div id="section2" className="section2-container">
                <div className="image"></div>
                <div className="desc-container">
                    <div className="title">העוני המוכר בישראל – קווים לדמותו</div>
                    <div className="desc">מהו קו העוני, מי נמצא מתחתיו ומה ההבדל בינו לבין המדדים החלופיים המוצעים לו?</div>
                    <button className="btn" onClick={() =>this.props.goToArticle('5341587/43', 'העוני המוכר בישראל – קווים לדמותו')}></button>
                </div>
            <div className="line"></div>
            </div>
        );
    }
}

export default SectionTwo;


// WEBPACK FOOTER //
// ./src/Components/SectionTwo/SectionTwo.js